import UploadPhotoModal from './UploadPhotoModal';
import { connect } from 'react-redux';

export default UploadPhotoModal;
